export const ALLERGY_CLINICAL_STATUS_SELECT_ID = 'allergy_clinical_status';
export const ALLERGY_VERIFICATION_STATUS_SELECT_ID = 'allergy_verification_status';
export const ALLERGY_TYPE_SELECT_ID = 'allergy_intolerance_type';
export const ALLERGY_CATEGORY_SELECT_ID = 'allergy_intolerance_category';
export const CONDITION_CLINICAL_STATUS_SELECT_ID = 'condition_clinical_status';
export const CONDITION_ONSET_SELECT_ID = 'onset';
export const CONDITION_SEVERITY_SELECT_ID = 'condition_severity';
export const CONDITION_VERIFICATION_STATUS_SELECT_ID = 'condition_verification_status';
export const CONDITION_CONTEXT_SELECT_ID = 'context';
export const CONDITION_TIMING_SELECT_ID = 'timing';
export const CONDITION_CATEGORY_SELECT_ID = 'condition_category';
export const PROCEDURE_CATEGORY_SELECT_ID = 'procedure_category';
export const PROCEDURE_STATUS_SELECT_ID = 'procedure_status';
export const MEDICATION_TIMING_ABBREVIATION_SELECT_ID = 'timing_abbreviation';
export const MEDICATION_DERIVATION_REASON_SELECT_ID = 'medication_derivation_reason_code';
export const MEDICATION_STATEMENT_STATUS_SELECT_ID = 'medication_status_codes';
export const MEDICATION_REQUEST_STATUS_SELECT_ID = 'medication_request_status';
export const MEDICATION_REQUEST_INTENT_SELECT_ID = 'medication_request_intent';
export const IMMUNIZATION_CODE_SELECT_ID = 'immunization_code';
export const IMMUNIZATION_STATUS_SELECT_ID = 'immunization_status';
export const TASK_APPOINTMENT_TYPE_SELECT_ID = 'appt_type';
export const TASK_CARE_TEAM_SELECT_ID = 'care_team';
export const TASK_ORDER_STATUS_SELECT_ID = 'request_status';
